<template>
  <breadCrumbs title="Product List" main="Ecommerce" title1="Product List" />

  <div class="container-fluid list-products">
    <div class="row">

      <div class="col-sm-12">
        <div class="card">
          <div class="card-header pb-0">
            <h3>Individual column searching (text inputs) </h3><span>The searching functionality provided by DataTables is
              useful for quickly search through the information in the table - however the search is global, and you may
              wish to present controls that search on specific columns.</span>
          </div>
          <div class="card-body">
            <div class="table-responsive product-table">
              <table class="table dataTable display" id="basic-1">
                <thead>
                  <tr>
                    <th>Image</th>
                    <th>Details</th>
                    <th>Amount</th>
                    <th>Stock</th>
                    <th>Start date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in menu" :key="index">
                    <td><router-link :to="'/ecommerce/product/page/' + item.id"><img :src="getImgUrl(item.image)"
                          alt=""></router-link></td>
                    <td><router-link :to="'/ecommerce/product/page/' + item.id">
                        <h4> {{ item.product_name }} </h4>
                      </router-link><span>{{ item.product_desc }}</span></td>
                    <td>{{ item.amount }}</td>
                    <td :class=item.class>{{ item.stock }}</td>
                    <td>{{ item.start_date }}</td>
                    <td>
                      <button class="btn btn-danger btn-xs me-1" type="button" data-original-title="btn btn-danger btn-xs"
                        title="">Delete</button>
                      <button class="btn btn-primary btn-xs" type="button" data-original-title="btn btn-danger btn-xs"
                        title="">Edit</button>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import data from '../../../data/productlist.json'
export default {
  name: 'productList',
  data() {
    return {
      menu: data.data
    }
  },
  methods: {
    getImgUrl(path) {
      return require("../../../assets/images/ecommerce/" + path);
    },
  }
}
</script>